module.exports = __webpack_public_path__ + "img/icon4@2x.d7458a60.png";